<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->

<div class="mb-3px mt-1 mb-1" *ngIf="candidatedetails.length !=0 && !showLoaderOnCandidateList">
  <!-- Bulk Reveal in process banner -->
  <div *ngIf="isprofile && isBulkRevealInProcess" id="bulk-process">
    <span class="process-env">
      <i class="fa-solid fa-envelope"></i>
    </span>
      <span class="bulk-process-text">
        A process has been queued to bulk find contact and add to campaign. On completion a summary report will be sent to {{userEmailId}}
      </span>
      <i class="fa-solid fa-xmark float-right mr-2" style="color: #2e93a1; margin-top: 3px; cursor: pointer;" (click)="removeBulkProcessDiv()"></i>
  </div>

  <!-- Bulk Reveal for whole talentpool -->
  <div *ngIf="isprofile && bulkRevealBannerTalentpoolLevel?.showBanner && !isBulkRevealInProcess" id="bulk-talentpool-level">
    <span class="">
      <i class="fa-solid fa-address-book" style="color: #e9ac0d;"></i>
    </span>
      <span class="bulk-process-text">
        {{bulkRevealBannerTalentpoolLevel?.user}}, {{bulkRevealBannerTalentpoolLevel?.bulkRevealPayLoad?.candidates?.length}} profile(s) in your talent pool don't have contact details.
        <span class="wc-btn bg-blue ml-2" (click)="openBulkRevealModal(bulkRevealBannerTalentpoolLevel?.bulkRevealPayLoad)" >
          Reveal Contact
        </span>
      </span>
      <i class="fa-solid fa-xmark float-right mr-2" style="color: #484b59;; margin-top: 3px; cursor: pointer;" (click)="removeBulkProcessDiv()"></i>
  </div>
</div>
<div class="col wccard py-2 px-3 talenpool-sticky-header"  *ngIf="candidatedetails.length !=0 && !showLoaderOnCandidateList">
  <div class="d-flex align-items-center">
    <label class="wc-checkbox mb-0">
      <input data-testid="auto-app-candidate-list-input-1" [(ngModel)]="selected" (change)="selectAll($event)" type="checkbox" id="mycheck" name="mycheck">
      <i class="fas fa-check" style="border-color: #2e93a1 ;"></i>
    </label>
    <span class="py-2 f-14 font-weight-500 pointer mr-2 pr-8 pl-4"
      [ngClass]="{'isActive': isprofile}"
      (click)="!isprofile && onTabChange('talentpoolCandidates')"
    >
      <i class="fa-regular fa-users mr-2"></i>Profiles
    </span>
    <span class="py-2 f-14 font-weight-500 pointer pr-8 pl-4" *ngIf="talentpoolid && talentpooldetails" (click)="!isSimilarCandidatesTabActive && onTabChange('similarCandidates')">
      <i class="fa-regular fa-users mr-2 ai-text-gradient"></i>
      <span [ngClass]="{'ai-text-gradient': isSimilarCandidatesTabActive}">Recommended Matches</span>
      <span *ngIf="!isSimilarCandidatesTabActive" class="ml-2 similar-candidates-chip-count f-12">
        <!-- show exact count if <= 99 else show 99+ static content -->
        {{talentpooldetails?.suggestedCandidatesCount ? (talentpooldetails?.suggestedCandidatesCount > 99 ? '99+' : talentpooldetails?.suggestedCandidatesCount) : 0}}
      </span>
    </span>
    <!-- <span class="py-2 f-14 font-weight-500 pointer px-8" (click)="onTabChange('candidates')"
      [ngClass]="{'isActive': isinsights}">
      <i class="fa-regular fa-files mr-2"></i>Insights
    </span> -->
    <span class="d-flex" style="position: absolute; right:20px;">
      <span class="d-flex align-items-center">
        <span class="dropdown ats-dropBtn" ngbDropdown placement="bottom-end" container="body">
          <button data-testid="auto-app-candidate-list-button-1" class="ats-btn btn-break dropdown-toggle ml-3px" title="Sort Candidates" type="button" id="userDropdownButton" *ngIf="isprofile"
            ngbDropdownToggle aria-haspopup="true" aria-expanded="false">
            <i class="far fa-sort-alt isActive mr-2"></i>Sort By
          </button>
          <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="userDropdownButton" style="width: 300px;">
            <a data-testid="auto-app-candidate-list-a-1" class="dropdown-item f-14" routerLinkActive="active" ngbDropdownItem
              (click)="sortcandidatelist('new')">Candidate Added on(Newest to Oldest)</a>
            <a data-testid="auto-app-candidate-list-a-2" class="dropdown-item f-14" routerLinkActive="active" ngbDropdownItem
              (click)="sortcandidatelist('old')">Candidate Added on(Oldest to Newest)</a>
            <a data-testid="auto-app-candidate-list-a-3" class="dropdown-item f-14" routerLinkActive="active" ngbDropdownItem
              (click)="sortcandidatelist('ascendingbyname')">Alphabetical Order(A to Z)</a>
            <a data-testid="auto-app-candidate-list-a-4" class="dropdown-item f-14" routerLinkActive="active" ngbDropdownItem
              (click)="sortcandidatelist('descendingbyname')">Alphabetical Order(Z to A)</a>
              <a data-testid="auto-app-candidate-list-a-5" class="dropdown-item f-14" routerLinkActive="active" ngbDropdownItem
              (click)="sortcandidatelist('ascendingbyactivity')">Last Updated On(Asc)</a>
              <a data-testid="auto-app-candidate-list-a-6" class="dropdown-item f-14" routerLinkActive="active" ngbDropdownItem
              (click)="sortcandidatelist('descendingbyactivity')">Last Updated On(Desc)</a>

          </div>
        </span>
        <!-- <span class="ml-2 ats-cta-btn position-relative pointer" (click)="DownloadCandidateCSV()" title="Download CSV">
          <i class="fas fa-cloud-download-alt"></i>
        </span> -->
        <div class="d-flex">
            <span class="ml-2 ats-cta-btn position-relative pointer" (click)="addtags()"
            title="Add Tags" *ngIf="selectedcandidate?.length > 0 && isCandidateSelected">
            <i class="fa-solid fa-tag"></i>
          </span>
          <span class="ml-2 ats-cta-btn position-relative pointer" (click)="openAddTalentpoolModal()"
          title="Add to Talent pool" *ngIf="selectedcandidate?.length > 0 && isCandidateSelected">
          <i class="fa-solid fa-users"></i>
        </span>

          <span class="ml-2 ats-cta-btn position-relative pointer" (click)="openAddNOtesModal()" title="Add notes" *ngIf="selectedcandidate?.length > 0 && isCandidateSelected">
            <i class="fas fa-sticky-note"></i>
          </span>
          <!-- <span class="ml-2 ats-cta-btn position-relative pointer" (click)="openSendBulkEmailModal()" *ngIf="selectedcandidate?.length > 0 && isCandidateSelected"
            title="Send email">
            <i class="fas fa-envelope"></i>
          </span> -->
          <span class="ml-2 ats-cta-btn position-relative pointer" (click)="triggerBulkDownloadCandidatesCSVModal()" *ngIf="selectedcandidate?.length > 0 && isCandidateSelected"
            title="Download CSV">
            <i class="fa-sharp fa-solid fa-file-csv"></i>
          </span>
          <span class="ml-2 mr-1 ats-cta-btn position-relative pointer" (click)="openAddToEmailCampaign({})" title="Add to Email Campaign" *ngIf="selectedcandidate?.length > 0 && isCandidateSelected">
            <i class="fa-solid fa-envelopes-bulk nr-2"></i>
          </span>
          <span class="ml-2 mr-1 ats-cta-btn position-relative pointer" (click)="openAddToScreenAiModal({})" title="Add to Screen AI" *ngIf="selectedcandidate?.length > 0 && isCandidateSelected">
            <i class="fa-solid fa-globe nr-2"></i>
          </span>
          <span class="ml-2 ats-cta-btn position-relative pointer" (click)="deleteCandidate()" title="Archive" *ngIf="!isSharedTalentpool && selectedcandidate?.length > 0 && isCandidateSelected">
            <i class="fa-solid fa-inbox"></i>
          </span>
            <span class="ml-2 ats-cta-btn position-relative pointer" (click)="addToAegis({})" title="Add to Aegis"
              *ngIf="selectedcandidate?.length > 0 && isCandidateSelected && isAegisConnected">
              <img src="../../assets/search/aegis.png" alt="A">
            </span>

          <!-- <div class="d-flex" *ngIf="isprofile && !isSimilarCandidatesTabActive">
            <button data-testid="auto-app-candidate-list-button-2" class="ml-2 btn-trms-white" (click)="filterSlider_open()"><i class="fa-light fa-filters mr-1 isActive"></i>Filters <span *ngIf="appliedfiltercount && appliedfiltercount >0">({{appliedfiltercount}})</span></button>
            <div *ngIf="checkTalentpoolIsShared">
            <button data-testid="auto-app-candidate-list-button-3"  [ngClass]="{'ml-2': !((enrichedFromForReveal === 'talentpool') && selectedcandidate?.length > 0 && candidatesWithoutContactInfo > 0) }" *ngIf="!((enrichedFromForReveal === 'talentpool') && selectedcandidate?.length > 0 && candidatesWithoutContactInfo > 0)" class="btn-trms-medium" (click)="openCreateCandidate()">+ Candidate</button>
              </div>
            <button data-testid="auto-app-candidate-list-button-4" [ngClass]="{'ml-2': (enrichedFromForReveal === 'talentpool') && selectedcandidate?.length > 0 && candidatesWithoutContactInfo > 0 }" *ngIf="(enrichedFromForReveal === 'talentpool') && selectedcandidate?.length > 0 && candidatesWithoutContactInfo > 0" class="btn-trms-medium" (click)="bulkRevealTalentpool()">Reveal Contact</button>
              </div> -->

            <div class="d-flex" *ngIf="isprofile && !isSimilarCandidatesTabActive">
              <button data-testid="auto-app-candidate-list-button-5" class="ml-2 btn-trms-white" (click)="filterSlider_open()"><i class="fa-light fa-filters mr-1 isActive"></i>Filters <span *ngIf="appliedfiltercount && appliedfiltercount >0">({{appliedfiltercount}})</span></button>
                <div *ngIf="checkTalentpoolIsShared">
                  <div class="no-outline p-0" style="border: none;" [ngClass]="{'ml-2': !((enrichedFromForReveal === 'talentpool') && selectedcandidate?.length > 0 && candidatesWithoutContactInfo > 0) }"
                    *ngIf="!((enrichedFromForReveal === 'talentpool') && selectedcandidate?.length > 0 && candidatesWithoutContactInfo > 0)">
                    <div class="dropdown" ngbDropdown placement="bottom-end" container="body">
                      <button data-testid="auto-app-candidate-list-button-6" class="d-flex border-0 btn-trms-light align-items-center justify-content-center"
                        style="min-width: auto !important; width: auto !important;" type="button" id="exportDropdownTop"
                        ngbDropdownToggle aria-haspopup="true" aria-expanded="false">
                        + Candidate <i class="fa-solid fa-chevron-down ml-1 f-11"></i>
                      </button>
                      <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu aria-labelledby="exportDropdownTop">
                        <button data-testid="auto-app-candidate-list-button-7" type="button" class="dropdown-item f-12 pointer" style="color: #2e93a1 !important" ngbDropdownItem
                          (click)="selectedCandidateCreatMode('create-candidate')">
                          Create Manually
                        </button>
                        <button data-testid="auto-app-candidate-list-button-8" type="button" class="dropdown-item f-12 pointer" style="color: #2e93a1 !important" ngbDropdownItem
                          (click)="selectedCandidateCreatMode('upload-cv')">
                          Bulk Upload CV
                        </button>
                        <button data-testid="auto-app-candidate-list-button-9" type="button" class="dropdown-item f-12 pointer" style="color: #2e93a1 !important" ngbDropdownItem
                          (click)="selectedCandidateCreatMode('csv')">
                          Import CSV
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              <button data-testid="auto-app-candidate-list-button-10" [ngClass]="{'ml-2': (enrichedFromForReveal === 'talentpool') && selectedcandidate?.length > 0 && candidatesWithoutContactInfo > 0 }" *ngIf="(enrichedFromForReveal === 'talentpool') && selectedcandidate?.length > 0 && candidatesWithoutContactInfo > 0" class="btn-trms-medium" (click)="bulkRevealTalentpool()">Reveal Contact</button>
          </div>
          <!-- </div> -->

          <div *ngIf="talentpoolid && isSimilarCandidatesTabActive && !isprofile">
            <button data-testid="auto-app-candidate-list-button-11" *ngIf="selectedSimilarCandidates?.length > 1" class="btn-trms-medium" [ngClass]="{ 'disable-btn': isLoadingForSimilarCandidates }" (click)="moveRecommendedCandidatesToTalentpool()" [disabled]="isLoadingForSimilarCandidates">
              <i class="fas fa-user-plus mr-1"></i>
              Move to Talent pool
            </button>
          </div>

        </div>
      </span>
    </span>

  </div>
</div>

<div>
  <app-candidate-filter *ngIf="isprofile" (filterEvent)="filterJobs($event)" [events]="removeSubject.asObservable()"></app-candidate-filter>

  <!-- talentpool candidates listing -->
  <div *ngIf="isprofile && candidatedetails?.length > 0">
    <div class="mb-3px" *ngFor="let data of candidatedetails; let i=index;">
      <div class="wccard mb-1 p-3">
        <div class="d-flex">
          <div>
          <label class="wc-checkbox">
            <input data-testid="auto-app-candidate-list-input-2" [checked]="data.selected" [(ngModel)]="data.selected" (change)="checkIfAllSelected(data, $event)"
              type="checkbox" id="mycheck" name="mycheck">
            <i class="fas fa-check" style="border-color: #2e93a1 ;"></i>
          </label>
        </div>
          <div>
            <!-- <div class="circular-img mr-3 mb-3 text-capitalize" [ngClass]="{
                    'lavender-circle': i % 4 == 0,
                    'yellow-circle': i % 4 == 1,
                    'blue-circle': i % 4 == 2,
                    'blue-circle': i % 4 == 3,
                    'teal-circle': i % 5 == 4
                  }">{{transform(data?.basicdetails?.firstname).charAt(0)}} {{transform(data?.basicdetails?.lastname).charAt(0)}}</div> -->
            <div class="canProfilePic position-relative ml-4">
              <i class="fas fa-user text-dis" *ngIf="!data?.basicdetails?.candidateimage"></i>
              <img src="{{data?.basicdetails?.candidateimage}}" class="img-fluid" alt="None"
                *ngIf="data?.basicdetails?.candidateimage">
            </div>
          </div>

          <div class="d-flex justify-content-between w-100 ml-4">
            <div>
              <span class="d-flex">
                <span>
                  <p class="mb-1 text-capitalize f-16 font-weight-600 pointer text-484b59"
                    (click)="OpenCandidateSlider(data.basicdetails,'details', data?.talentpoolMappingDetails)" *ngIf="data?.basicdetails?.firstname">
                    {{data?.basicdetails?.firstname}} {{data?.basicdetails?.middlename}} {{data?.basicdetails?.lastname}}
                  </p>
                </span>
              </span>
              <p class="f-14 text-484b59 mb-1 f-14">
                <span *ngIf="data?.basicdetails?.jobtitle">{{data?.basicdetails?.jobtitle | titlecase}}</span>
                <span *ngIf="data?.basicdetails?.jobtitle && data?.basicdetails?.companyname"> at </span>
                <span class="" *ngIf="data?.basicdetails?.companyname"  (mouseenter)="getCompanyInfo(data?.basicdetails, 'exp')"  [ngClass]="{'companyHover': data?.basicdetails?.website, 'dstooltip pointer':data?.basicdetails?.website}">{{data?.basicdetails?.companyname | titlecase}}
                  <span class="dstooltip-content">
                    <app-company-hover-modal [companyInformation]="currentCompanyInformation"></app-company-hover-modal>
                  </span>
                </span>
              </p>
              <p class="f-12 mb-1 d-flex align-items-center">
                <i class="far fa-map-marker-alt mr-1 text-9696" *ngIf="data?.basicdetails?.locationname"></i>
                <span *ngIf="data?.basicdetails?.locationname"
                  class="text-9696 text-capitalize">{{data?.basicdetails?.locationname}}</span>
                <i class="fas fa-circle text-d9d9d9 mx-2 text-9696" style="font-size:5px"
                  *ngIf="data?.basicdetails?.locationname && data?.basicdetails?.totalexperience"></i>
                <span matTooltip="Total years of experience" [matTooltipClass]="{ 'red-tooltip text-black': true }"
                  class="text-9696">
                  <i class="far fa-briefcase mr-1" *ngIf="data?.basicdetails?.totalexperience"></i>
                  <span *ngIf="data?.basicdetails?.totalexperience"
                    class="text-9696">{{getFormattedTenure(data?.basicdetails?.totalexperience)}}</span>
                </span>
  <!--
                <i class="fas fa-circle text-d9d9d9 mx-2 mr-1 text-9696" style="font-size:5px"
                  *ngIf="(data?.linkedin_url || data?.twitter_url || data?.facebook_url)"></i> -->

                <i class="fas fa-circle text-d9d9d9 mx-2" style="font-size:5px"
                  *ngIf="(data?.basicdetails?.locationname || data?.basicdetails?.totalexperience) && (data?.basicdetails?.profileurl || data?.twitter_url || data?.facebook_url || data?.github_url)"></i>


                <!-- <a data-testid="auto-app-candidate-list-a-7" target="_blank" rel="noopener noreferrer" *ngIf="linkedin_url"
                  (click)="openUrl(linkedin_url, 'linkedin')" class="mr-2">

                  <i class="fa fa-linkedin-square f-16" aria-hidden="true" style="color: #0652ba;"></i>

                </a> -->

                  <span class="mr-2" *ngIf="data?.basicdetails?.profileurl"  title="Linkedin">
                    <a data-testid="auto-app-candidate-list-a-8" class="f-14 text-black" (click)="openUrl(data?.basicdetails?.profileurl, 'linkedin')"
                     [ngClass]="{'p-none' : data?.basicdetails?.profileurl?.includes('****')}">
                      <i class="fa fa-linkedin-square" style="color: #0652ba;"  [ngClass]="{'text-9696' : data?.basicdetails?.profileurl?.includes('****')}"></i></a>
                    </span>
                    <span class="mr-2" *ngIf="data?.twitter_url" title="{{data?.twitter_url?.platformname}}">
                      <a data-testid="auto-app-candidate-list-a-9" class="f-14 text-black" (click)="openUrl(data?.twitter_url?.link, 'twitter')"  [ngClass]="{'p-none' : data?.twitter_url?.link.includes('****')}">
                        <i class="fa-brands fa-square-x-twitter" style="color: #000000;"  [ngClass]="{'text-9696' : data?.twitter_url?.link.includes('****')}"></i></a>
                    </span>
                    <span class="mr-2" *ngIf="data?.facebook_url" title="{{data?.facebook_url?.platformname}}">
                      <a data-testid="auto-app-candidate-list-a-10" class="f-14 text-black" (click)="openUrl(data?.facebook_url?.link, 'facebook')"  [ngClass]="{'p-none' : data?.facebook_url?.link.includes('****')}">
                        <i class="fab fa-facebook" style="color: #1773ea;"  [ngClass]="{'text-9696' : data?.facebook_url?.link.includes('****')}"></i></a>
                    </span>
                    <span class="mr-2" *ngIf="data?.github_url" title="{{data?.github_url?.platformname}}">
                      <a data-testid="auto-app-candidate-list-a-11" class="f-14 text-black" (click)="openUrl(data?.github_url?.link, 'github')"  [ngClass]="{'p-none' : data?.github_url?.link.includes('****')}">
                        <i class="fab fa-github f-16" style="color: black;"  [ngClass]="{'text-9696' : data?.github_url?.link.includes('****')}"></i></a>
                    </span>


              </p>
            </div>
            <div>
              <span class="ml-2 ats-cta-btn position-relative pointer" *ngIf="!isCandidateSelected ||selectedcandidate?.length == 0" (click)="addtags(data)" title="Add tags">
                <i class="fa-solid fa-tag"></i>
              </span>
              <!-- <span class="ml-2 ats-cta-btn position-relative pointer" (click)="openSendBulkEmailModal(data)"
                title="Send email">
                <i class="fas fa-envelope"></i>
              </span> -->
              <!-- <span class="ml-2 ats-cta-btn position-relative pointer" (click)="DownloadCandidateCSV()"
                title="Download CSV">
                <i class="fa-sharp fa-solid fa-file-csv"></i>
              </span> -->
              <span class="dropdown ats-dropBtn ml-2" ngbDropdown placement="bottom-end" container="body">
                <button data-testid="auto-app-candidate-list-button-12" class="ats-btn btn-break dropdown-toggle ml-3px" type="button" id="userDropdownButton"
                  ngbDropdownToggle aria-haspopup="true" aria-expanded="false">
                  <i class="fas fa-ellipsis-v"></i>
                </button>
                <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="userDropdownButton">
                  <a data-testid="auto-app-candidate-list-a-12" class="dropdown-item f-12 isActive mr-2" routerLinkActive="active" ngbDropdownItem
                    (click)="openAddNOtesModal(data)"><i class="fas fa-sticky-note mr-2"></i>Add Notes</a>
                  <a data-testid="auto-app-candidate-list-a-13" class="dropdown-item f-12 isActive mr-2" routerLinkActive="active" ngbDropdownItem
                    (click)="openAddTalentpoolModal(data)"> <i class="fa-solid fa-users mr-2"></i>Add to Talent pool</a>
                  <a data-testid="auto-app-candidate-list-a-14" class="dropdown-item f-12 isActive mr-2" routerLinkActive="active" ngbDropdownItem (click)="openAddToEmailCampaign(data)"> <i
                      class="fa-solid fa-envelopes-bulk mr-2"></i>Add to Email Campaign </a>
                  <a data-testid="auto-app-candidate-list-a-15" class="dropdown-item f-12 isActive mr-2" routerLinkActive="active" ngbDropdownItem (click)="openAddToScreenAiModal(data)"> <i
                      class="fa-solid fa-globe mr-2"></i>Add to Screen AI </a>
                      <a data-testid="auto-app-candidate-list-a-16" class="dropdown-item f-12 isActive mr-2" routerLinkActive="active" *ngIf="isAegisConnected" (click)="addToAegis(data)">
                        <img style="height: 20px; width: 20px;" src="../../assets/search/aegis.png" alt="A"> Add to Aegis
                      </a>
                      <a data-testid="auto-app-candidate-list-a-17" *ngIf="!isSharedTalentpool && data.basicdetails.actualuserid == currentUser" class="dropdown-item f-12 isActive mr-2" routerLinkActive="active" (click)="deleteCandidate(data)"><i
                      class="fa-solid fa-inbox mr-2"></i>Archive</a>
                  <a data-testid="auto-app-candidate-list-a-18" class="dropdown-item f-12 isActive mr-2" routerLinkActive="active" ngbDropdownItem (click)="exportToPDF(data)">
                    <i class="fa-solid fa-download mr-2"></i>Export to PDF
                  </a>
                </div>
              </span>
            </div>
          </div>
        </div>
  <hr class="my-1" style="border-top:1px solid #d9d9d9">
        <!-- contacts -->
        <div class="d-flex mt-2 align-items-start mb-2" >
          <div class="d-flex justify-content-end w-100px">
            <span class="text-9696 mr-3 f-12" style="margin-top: 1px;">Contact:</span>
          </div>
          <div class="d-flex justify-content-between w-100">
            <div class="f-12 d-flex align-items-start" *ngIf="!(data?.talentpoolMappingDetails?.bulkcontactrevealstatus === 1)">
              <div class="d-flex align-items-start textBox"  [class.viewMore]="viewMore" [ngClass]="{'textBox': (data?.personal_email?.length>2 || data?.work_email?.length >2 ||  data?.mobile_phone?.length>2)}">
                <span *ngIf="data?.personal_email">
                <!-- <span class="mr-2" *ngIf="data?.personal_email?.length==0 && (data?.hasemailreveal || data?.hascontactreveal)">
                  <i class="fas fa-lock text-green mr-1"></i>
                  <span class="text-9696 f-12">Personal Email</span>
                </span> -->
                <span class="d-flex flex-column mr-4" *ngIf="data?.personal_email?.length && (!data?.hasemailreveal || !data?.hascontactreveal)">
                  <span *ngFor="let email of data?.personal_email" class="d-flex align-items-start mb-1">
                    <span *ngIf="email?.contactdetail != null && email?.contactdetail != false">
                    <i class="fas fa-envelope text-9696 mr-2"></i>
                    <img [src]="'../../assets/icons/data-providers/' + email.enrichedvia + '.png'" [alt]="email.enrichedvia" style="width: 15px;" *ngIf="email.enrichedvia && (email.enrichedvia !=='added-manually')" class="mr-1">
                    <span class="f-12">{{ email?.contactdetail }}</span>
                  </span>
                  </span>
                </span>
              </span>
              <span *ngIf="data?.work_email">
                <!-- <span class="mr-2" *ngIf="data?.work_email?.length == 0 && (data?.hasemailreveal || data?.hascontactreveal)">
                  <i class="fas fa-lock text-green mr-1"></i>
                  <span class="text-9696 f-12">professional Email</span>
                </span> -->
                <span class="d-flex flex-column mr-4" *ngIf="data?.work_email?.length">
                  <span *ngFor="let email of data?.work_email" class="d-flex align-items-baseline mb-1">
                    <span *ngIf="email?.contactdetail != null && (email?.contactdetail != false || email?.contactdetail != 'false')">
                    <i class="fas fa-envelope text-9696 mr-2"></i>
                    <img [src]="'../../assets/icons/data-providers/' + email.enrichedvia + '.png'" [alt]="email.enrichedvia" style="width: 15px;" *ngIf="email.enrichedvia && (email.enrichedvia !=='added-manually')" class="mr-1">

                    <span class="f-12">{{ email?.contactdetail }}</span>
                    </span>
                  </span>
                </span>
              </span>
              <span >
                <!-- <span class="mr-2" *ngIf="data?.mobile_phone?.length == 0 && (data?.hasemailreveal || data?.hascontactreveal)">
                <i class="fas fa-lock text-green mr-1"></i>
                <span class="text-9696 f-12">Phone</span>
              </span> -->
              <span class="d-flex flex-column mr-4" *ngIf="data?.mobile_phone?.length">
                <span *ngFor="let phone of data?.mobile_phone" class="d-flex align-items-center mb-1">
                  <i class="fas fa-phone text-9696 mr-2"></i>
                  <img [src]="'../../assets/icons/data-providers/' + phone.enrichedvia + '.png'" [alt]="phone.enrichedvia" style="width: 15px;" *ngIf="phone.enrichedvia && (phone.enrichedvia !=='added-manually')" class="mr-1">
                  <span class="f-12">{{ phone?.contactdetail }}</span>
                </span>
              </span>
              </span>

              </div>
              <span class="reveal-cand pointer" *ngIf="data?.hasemailreveal && data?.hascontactreveal && !data?.contactRevealStatus" (click)="opensliderforContacts(data.basicdetails,'contact')">
                <i class="fas fa-address-book mr-1"></i>
                <span class="" *ngIf="!data?.contactRevealStatus">Explore Contacts</span>

              </span>

              <span class="font-weight-600" *ngIf="data?.hasemailreveal && data?.hascontactreveal && data?.contactRevealStatus == 'reveal-contact-clicked'">
                <span class="" *ngIf="data?.contactRevealStatus == 'reveal-contact-clicked'"><i class="fa-solid fa-magnifying-glass mr-1"></i> Finding Contact</span>
              </span>
              <span class="f-10 text-webbtree-green text-right pointer" *ngIf="data?.work_email?.length >2 || data?.personal_email?.length>2 || data?.mobile_phone?.length>2" style="width: 90px;"(click)="viewMore = !viewMore">{{ viewMore ? 'View less': 'View More' }} <i class="far f-10 font-weight-500" [ngClass]="viewMore ? 'fa-angle-up': 'fa-angle-down'"></i>
              </span>
              <!-- <span class="d-flex">
                <span class="d-flex flex-column mr-4" *ngIf="data?.personal_email?.length && (!data?.hasemailreveal || !data?.hascontactreveal)">
                  <span *ngFor="let email of data?.personal_email" class="d-flex align-items-baseline">
                    <i class="fas fa-envelope text-9696"></i>
                    <span class="f-14 font-weight-500 text-9696">{{ email?.contactdetail }}</span>
                  </span>
                </span>
                <span class="d-flex flex-column mr-4" *ngIf="data?.mobile_phone?.length">
                  <span *ngFor="let phone of data?.mobile_phone" class="d-flex align-items-baseline">
                    <i [ngClass]="phone.icon" class="mx-1 text-9696" [title]="phone.text"></i>
                    <span class="f-14 font-weight-500">{{ phone?.contactdetail }}</span>
                  </span>
                </span>
                <span class="d-flex flex-column mr-4" *ngIf="data?.work_email?.length">
                  <span *ngFor="let email of data?.work_email" class="d-flex align-items-baseline">
                    <i class="fas fa-envelope text-9696"></i>
                    <span class="f-14 font-weight-500 text-9696">{{ email?.contactdetail }}</span>
                  </span>
                </span>
              </span> -->
            </div>
            <span class="font-weight-600" *ngIf="data?.talentpoolMappingDetails?.bulkcontactrevealstatus === 1">
              <i class="fa-solid fa-magnifying-glass mr-1"></i> Finding Contact
            </span>
          </div>

        </div>
        <!-- <hr class="mt-1 mb-2" style="border-top:1px solid #d5dee6"> -->


        <!-- contacts -->
        <!-- <div *ngIf="(!data?.hasnorevealinfo && (data?.contactdetails?.emails && data?.contactdetails?.emails?.existingDetails?.length > 0 || res?.contactdetails?.contact && res?.contactdetails?.contact?.existingDetails?.length > 0))" class="d-flex mt-2 align-items-baseline">
          <div class="d-flex justify-content-end w-100px">
            <span class="text-9696 mr-3 f-12">Contact</span>
          </div>
          <div class="d-flex justify-content-between w-100">
            <div class="mb-2 f-12 d-flex align-items-baseline">
              <span class="d-flex">
                <span class="d-flex flex-column mr-4" *ngIf="data?.personal_email?.length">
                  <span *ngFor="let email of data?.personal_email" class="d-flex align-items-baseline">
                    <i [ngClass]="email.icon" class="mx-1 text-9696" [title]="email.text"></i>
                    <span class="f-14 font-weight-500">{{ email?.data[0] }}</span>
                  </span>
                </span>
                <span class="d-flex flex-column mr-4" *ngIf="data?.mobile_phone?.length">
                  <span *ngFor="let phone of data?.mobile_phone" class="d-flex align-items-baseline">
                    <i [ngClass]="phone.icon" class="mx-1 text-9696" [title]="phone.text"></i>
                    <span class="f-14 font-weight-500">{{ phone?.data[0] }}</span>
                  </span>
                </span>
                <span class="d-flex flex-column mr-4" *ngIf="data?.work_email?.length">
                  <span *ngFor="let email of data?.work_email" class="d-flex align-items-baseline">
                    <i [ngClass]="email.icon" class="mx-1 text-9696" [title]="email.text"></i>
                    <span class="f-14 font-weight-500">{{ email?.data[0] }}</span>
                  </span>
                </span>
                <span class="d-flex flex-column mr-4" *ngIf="revealableInfoObj?.personal_email?.length">
                  <span *ngFor="let email of revealableInfoObj?.personal_email" class="d-flex align-items-baseline">
                    <i [ngClass]="email.icon" class="mx-1 text-9696" [title]="email.text"></i>
                    <span class="f-14 font-weight-500">{{ email?.data[0] }}</span>
                  </span>
                </span>
              </span>
            </div>
          </div>
        </div> -->
        <div class="d-flex align-items-baseline mt-1" (click)="opensliderforContacts(data.basicdetails,'contact')" *ngIf="data.canShowLookingMore && !(data?.talentpoolMappingDetails?.bulkcontactrevealstatus === 1)">

          <div class="d-flex" style="width: 118px;">
          </div>

          <div class="d-flex">
                <p class="f-12 text-webbtree-green pointer mb-2"><img src="../../assets/icons/file-circle-info.png" alt="" style="height: 14px;"> Looking for more contact details?</p>
            </div>
        </div>
        <!-- current experience -->

        <div class="d-flex align-items-baseline mb-1" *ngIf="data?.currentexprience?.length > 0">
          <div class="d-flex justify-content-end w-100px">
            <span class="text-9696 mr-3 f-12">Current Exp:</span>
          </div>
          <div class="w-100">
            <div class="f-14 d-flex align-items-center flex-wrap">
              <span class="mb-2">
                <span class="f-14 text-capitalize" *ngIf="data?.currentexprience[0]?.jobtitle">{{data?.currentexprience[0]?.jobtitle}}
                </span>
                 <span *ngIf="data?.currentexprience[0]?.jobtitle && data?.currentexprience[0]?.companyname"> at </span>
                <span class="text-capitalize" (mouseenter)="getCompanyInfo(data?.currentexprience[0], 'exp')"  [ngClass]="{'companyHover': data?.currentexprience[0]?.website, 'dstooltip pointer':data?.currentexprience[0]?.website}">{{data?.currentexprience[0]?.companyname}}
                  <span class="dstooltip-content">
                    <app-company-hover-modal [companyInformation]="currentCompanyInformation"></app-company-hover-modal>
                  </span>


                </span>
              </span>
              <i class="fas fa-circle text-d9d9d9 mx-2 text-webbtree-green"
                *ngIf="(data?.currentexprience[0]?.jobtitle || data?.currentexprience[0]?.companyname) && data?.currentexprience[0]?.locationname"
                style="font-size:5px"></i>
              <span>
                <span class="text-9696 text-capitalize"
                  *ngIf="data?.currentexprience[0]?.locationname">{{data?.currentexprience[0]?.locationname}}</span>
              </span>
              <span *ngIf="data?.currentexprience[0]?.startdate" class="d-flex align-items-center">
                <i class="fas fa-circle text-d9d9d9 mx-2 text-webbtree-green" style="font-size:5px"></i>
                <span class="text-9696">{{data?.currentexprience[0]?.startdate | moment: 'MMM YYYY'}}
                  <span>
                    - Current
                  </span>
                  <span *ngIf="data?.currenttenure">
                    ({{data?.currenttenure}})
                  </span>
                </span>
              </span>
            </div>
          </div>
        </div>

        <!-- past experience -->

        <div class="d-flex" *ngIf="data?.pastexperience?.length > 0">
          <div class="d-flex justify-content-end w-100px">
            <span class="text-9696 mr-3 f-12">Past Exp:</span>
          </div>
          <div class="w-100 mb-2" id="exp_less{{i}}">
            <div class="mb-2 f-14 d-flex flex-wrap align-items-baseline"
              *ngFor="let exp of data?.pastexperience | slice:0:2; let j = index">
              <span class="f-14 text-capitalize" *ngIf="exp?.jobtitle" matTooltip="{{exp?.jobtitle}}" [matTooltipClass]="{ 'red-tooltip text-black': true }">{{exp?.jobtitle | titlecase}}</span>
              <span class="mx-1" *ngIf="exp?.jobtitle && exp?.companyname"> at </span>
              <span class="text-capitalize" (mouseenter)="getCompanyInfo(exp, 'exp')"  [ngClass]="{'companyHover': exp?.website, 'dstooltip pointer':exp?.website}">
                {{exp?.companyname}}
                <span>
                  <span class="dstooltip-content">
                    <app-company-hover-modal [companyInformation]="currentCompanyInformation"></app-company-hover-modal>
                  </span>
                </span>
              </span>
              <i class="fas fa-circle text-d9d9d9 mx-2 text-webbtree-green"
                *ngIf="(exp?.jobtitle || exp?.companyname) && exp?.locationname" style="font-size:5px"></i>
              <span class="text-9696 text-capitalize" *ngIf="exp?.locationname" matTooltip="{{exp?.locationname}}" [matTooltipClass]="{ 'red-tooltip text-black': true }"> <span class="text-truncate">{{exp?.locationname}}</span></span>
              <span *ngIf="exp?.startdate && (exp?.enddate || exp.iscurrent == 1)">
                <i class="fas fa-circle text-d9d9d9 mx-2 text-webbtree-green"
                  *ngIf="exp?.startdate && (exp?.enddate || exp?.iscurrent== 1)" style="font-size:5px"></i>
                <span class="text-9696" *ngIf="exp?.startdate">{{exp?.startdate | moment: 'MMM YYYY'}} </span>
                <span class="text-9696" *ngIf="exp?.enddate">
                  - {{exp?.enddate | moment: 'MMM YYYY'}}
                </span>
                <span class="text-9696" *ngIf="exp?.iscurrent== 1">
                  - Current
                </span>
                <span class="text-9696" *ngIf="exp?.totaltenure">&nbsp;({{exp?.totaltenure}})
                </span>

              </span>
              <span *ngIf="data?.pastexperience?.length > 2 && j == 1" class="f-12 text-webbtree-green pointer ml-2"
                (click)="viewmoredetails('exp', i , 'viewmore')">
                + {{data?.pastexperience?.length - 2}} more
              </span>
            </div>
          </div>
          <div class="w-100 mb-2" id="exp_more{{i}}" style="display: none;">
            <div class="mb-2 f-14" style="display: block;" *ngFor="let exp of data?.pastexperience; let x = index">
              <span class="f-14 text-capitalize" *ngIf="exp?.jobtitle" matTooltip="{{exp?.jobtitle}}" [matTooltipClass]="{ 'red-tooltip text-black': true }">{{exp?.jobtitle | titlecase}}</span>
              <span class="mx-1" *ngIf="exp?.jobtitle && exp?.companyname">at</span>
              <span class="text-capitalize" (mouseenter)="getCompanyInfo(exp, 'exp')"  [ngClass]="{'companyHover': exp?.website, 'dstooltip pointer':exp?.website}">
                {{exp?.companyname}}
                <span>
                  <span class="dstooltip-content">
                    <app-company-hover-modal [companyInformation]="currentCompanyInformation"></app-company-hover-modal>
                  </span>
                </span>
              </span>
              <i class="fas fa-circle text-d9d9d9 mx-2 text-webbtree-green"
                *ngIf="(exp?.jobtitle || exp?.companyname) && exp?.locationname" style="font-size:5px"></i>
              <span class="text-9696" *ngIf="exp?.locationname">{{exp?.locationname | titlecase}}</span>
              <span *ngIf="exp?.startdate && (exp?.enddate || exp.iscurrent == 1)">
                <i class="fas fa-circle text-d9d9d9 mx-2 text-webbtree-green"
                  *ngIf="exp?.startdate && (exp?.enddate || exp.iscurrent== 1)" style="font-size:5px"></i>
                <span class="text-9696" *ngIf="exp?.startdate">{{exp?.startdate | moment: 'MMM YYYY'}} </span>
                <span class="text-9696" *ngIf="exp?.enddate">
                  - {{exp?.enddate | moment: 'MMM YYYY'}}&nbsp;
                </span>
                <span class="text-9696" *ngIf="exp?.iscurrent== true">
                  - Current
                </span>
                <span class="text-9696" *ngIf="exp?.totaltenure">
                  ({{exp?.totaltenure}})
                </span>
              </span>
              <span *ngIf="x == (data?.pastexperience?.length -1)" class="f-12 text-webbtree-green pointer ml-2"
                (click)="viewmoredetails('exp', i , 'less')">
                view less
              </span>
            </div>
          </div>
        </div>

        <hr class="mt-0 mb-3" style="border-top:1px solid #d9d9d9" *ngIf="showActivity(data)">

        <div class="d-flex align-items-baseline mt-2" *ngIf="showActivity(data)">
          <div class="d-flex justify-content-end w-100px">
            <span class="text-9696 mr-3 f-12">Activity:</span>
          </div>
          <div class="w-100">
            <div class="f-14 d-flex align-items-center flex-wrap">
              <span *ngIf="data?.candidatetagscount > 0" class="d-flex align-items-center mr-3"
                (click)="OpenCandidateSlider(data.basicdetails,'details')">
                <span class="tag-btn position-relative pointer" matBadgeHidden="{{data?.candidatetagscount == 0 }}"
                  matBadge="{{data?.candidatetagscount}}" matBadgeSize="small" matBadgeOverlap="false">
                  <i class="fa-solid fa-tag"></i>
                </span><span class="ml-2 pointer">Tags</span>
              </span>


              <span *ngIf="data?.candidatenotecount > 0" class="d-flex align-items-center mr-3"
                (click)="OpenCandidateSlider(data.basicdetails,'notes')"> <span class="tag-btn position-relative pointer"
                  matBadgeHidden="{{data?.candidatenotecount == 0 }}" matBadge="{{data?.candidatenotecount}}" matBadgeSize="small"
                  matBadgeOverlap="false">
                  <i class="fas fa-sticky-note"></i>
                </span><span class="ml-2 pointer">Notes</span></span>

              <span *ngIf="data?.candidatefilecount > 0" class="d-flex align-items-center mr-3"
                (click)="OpenCandidateSlider(data.basicdetails,'files')"> <span class="tag-btn position-relative pointer"
                  matBadgeHidden="{{data?.candidatefilecount == 0 }}" matBadge="{{data?.candidatefilecount}}" matBadgeSize="small"
                  matBadgeOverlap="false">
                  <i class="fa-light fa-file"></i>
                </span><span class="ml-2 pointer">Files</span></span>

              <span *ngIf="data && data.talentpoolcount" class="mr-3" style="margin-right: 15px;">
                <i class="fas fa-users f-16 text-webbtree-green pointer activity-icon" matTooltip="Added to talentpool"
                  [matTooltipClass]="{ 'red-tooltip text-black': true }" matBadge="{{data.talentpoolcount}}" matBadgeSize="small"
                  matBadgeOverlap="false" (click)="OpenCandidateSlider(data.basicdetails,'taggedto')" style="margin-right: 1px;"></i>
                Talentpool
              </span>

              <span *ngIf="data && data.emailcampaigncount" class="mr-3">
                <i class="fa-solid f-16 fa fa-envelope text-webbtree-green pointer activity-icon"
                  matTooltip="Added to email campaign" [matTooltipClass]="{ 'red-tooltip text-black': true }"
                  matBadge="{{data.emailcampaigncount}}" matBadgeSize="small" matBadgeOverlap="false"
                  (click)="OpenCandidateSlider(data.basicdetails,'taggedto')" style="margin-right: 1px;"></i>
                Email Campaign
              </span>
              <span *ngIf="data && data.iswebbtreeverified" class="d-flex align-items-center mr-3">
                <span class="pointer mr-1" (click)="OpenCandidateSlider(data.basicdetails,'activity')"
                  matTooltip="Webbtree Verified Requested" [matTooltipClass]="{ 'red-tooltip text-black': true }">
                  <img style="width: 20px;" src="./../../assets/webbtree_verified.png" />
                </span>
                Webbtree verified
              </span>
              <span *ngIf="data && data.usedWebbtreeIntroduction" class="d-flex align-items-center mr-3">
                <span class="pointer mr-1" (click)="OpenCandidateSlider(data.basicdetails,'activity')"
                  matTooltip="Webbtree Introduction Requested" [matTooltipClass]="{ 'red-tooltip text-black': true }">
                  <img style="width: 20px;" src="./../../assets/webbtree_verified.png" />
                </span>
                Webbtree Introduction
              </span>
              <span *ngIf="data && data.unifieddropped" class="mr-3">
                <i class="fa-solid fa-puzzle f-16 text-webbtree-green pointer activity-icon" matTooltip="Added to ATS"
                  [matTooltipClass]="{ 'red-tooltip text-black': true }" (click)="OpenCandidateSlider(data.basicdetails,'activity')"
                  style="margin-right: 1px;"></i>
                Added to ATS
              </span>
              <span *ngIf="data && data.screenaicount" class="mr-3">
                <i class="fa-solid fa-globe f-16 text-webbtree-green pointer activity-icon" matBadge="{{data.screenaicount}}" matBadgeSize="small" matBadgeOverlap="false" matTooltip="Added to ScreenAI Job"
                  [matTooltipClass]="{ 'red-tooltip text-black': true }" (click)="OpenCandidateSlider(data.basicdetails,'activity')"
                  style="margin-right: 1px;"></i>
                Added to ScreenAI Job
              </span>
              <span class="text-9696 d-flex align-items-center ml-auto" matTooltip="Last Activity: {{data?.lastactivity}}"
                  [matTooltipClass]="{ 'red-tooltip text-black': true }">
                <i class="fa-regular fa-clock f-10 mr-1"></i><span
                  class="f-12 text-9696">{{data?.lastactivity}}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- similar candidates listing -->
  <div *ngIf="talentpoolid && isSimilarCandidatesTabActive">
    <app-talentpool-suggested-candidate-list [talentpoolNumber]="talentpooldetails?.talentpoolnumber" (eventEmitter)="handleTalentpoolSuggestionEvents($event)" [eventListener]="similarCandidatesEventEmitter.asObservable()"></app-talentpool-suggested-candidate-list>
  </div>
</div>
<div class="d-flex justify-content-center wccard" [ngClass]="{'sticky-pagination': isScrolled}" *ngIf="!isprofile ? (talentpooldetails?.suggestedCandidatesCount > 0) : !showLoaderOnCandidateList">
  <ngb-pagination [collectionSize]="isprofile ? (candidateTotalCount) : (talentpooldetails?.suggestedCandidatesCount <= 200 ? talentpooldetails?.suggestedCandidatesCount : 200)" [maxSize]="5" [pageSize]="profilesPerPage" [rotate]="true"
      (pageChange)="setPage($event)" [(page)]="currentPage">
      <ng-template ngbPaginationPrevious> <span *ngIf="candidateTotalCount > profilesPerPage">
              Previous
          </span></ng-template>
      <ng-template ngbPaginationNext> <span *ngIf="candidateTotalCount > profilesPerPage">Next</span> </ng-template>
  </ngb-pagination>

  <div class="page-selection">
    Showing
    <select data-testid="auto-app-candidate-list-select-1" class="wc-select" name="" id="" [(ngModel)]="profilesPerPage" (change)="updatePagePreference()">
        <option value="10">10</option>
        <option value="25">25</option>
        <option value="50">50</option>
    </select>
    Profiles per page
  </div>

</div>
<app-candidate-slider [events]="parentSubject.asObservable()" (refreshCandidateListEvent)="getsliderdata($event, 'fromSlider')"  (openModalEvent)="openAddToEmailCampaignModal()"  (revealStatusEventEmitter)="getRevealStatus($event)"></app-candidate-slider>
<div class="emptyScreen" *ngIf="(candidatedetails?.length == 0) && !showLoaderOnCandidateList">
  <div class="py-4 justify-content-center wccard d-flex flex-column align-items-center" style="height: calc(100vh - 110px);" *ngIf="isFilterApplied">
    <img src="../../assets/emptystate.png" class="empty-state-img"/>
    <!-- <p class="f-18 font-weight-600 mt-6">Results Not Found!</p> -->
    <p class="f-16 font-weight-600 mt-6">No Profiles found.</p>

    </div>

  <div class="createFirstTalenpool" *ngIf="!isFilterApplied">
      <div class="text-center">
        <div class="text-center mb-3"><img src="../../../assets/images/bacgroundvectore-2.png" alt="" style="width: 110px;"></div>
        <p *ngIf="!isSharedTalentpool" class="f-16 font-weight-600 text-center">Add Your first candidate</p>
        <p *ngIf="isSharedTalentpool" class="f-16 font-weight-600 text-center">No candidate added</p>
        <div class="no-outline p-0" style="border: none;" *ngIf="!isSharedTalentpool">
          <div class="dropdown" ngbDropdown placement="bottom-end" container="body">
            <button data-testid="auto-app-candidate-list-button-13" class="d-flex border-0 btn-trms-light align-items-center justify-content-center mx-auto"
              style="min-width: auto !important; width: auto !important;" type="button" id="exportDropdownTop"
              ngbDropdownToggle aria-haspopup="true" aria-expanded="false">
              + Candidate <i class="fa-solid fa-chevron-down ml-1 f-11"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu aria-labelledby="exportDropdownTop">
              <button data-testid="auto-app-candidate-list-button-14" type="button" class="dropdown-item f-12 pointer" style="color: #2e93a1 !important" ngbDropdownItem
                (click)="selectedCandidateCreatMode('create-candidate')">
                Create Manually
              </button>
              <button data-testid="auto-app-candidate-list-button-15" type="button" class="dropdown-item f-12 pointer" style="color: #2e93a1 !important" ngbDropdownItem
                (click)="selectedCandidateCreatMode('upload-cv')">
                Bulk Upload CV
              </button>
              <button data-testid="auto-app-candidate-list-button-16" type="button" class="dropdown-item f-12 pointer" style="color: #2e93a1 !important" ngbDropdownItem
                (click)="selectedCandidateCreatMode('csv')">
                Import CSV
              </button>
            </div>
          </div>
        </div>
      </div>
  </div>

</div>

<div class="emptyScreen" *ngIf="showLoaderOnCandidateList">
  <div class="loader text-center">
    <img style="width: 75px;" src="../../assets/rolling-loader.gif" alt="loader" />
  </div>
</div>
<!-- <div class="" *ngIf="candidatedetails.length == 0">
  <div class="col-md-12 wccard text-center">
    <div class="row mt-3">
      <div class="col">
        <img src="../assets/images/undraw-empty-xct-9-1.png" class="img-fluid" alt="" srcset="">
      </div>
    </div>
    <div class="row">

    </div>
    <div>
      <p class="font-weight-500 f-18 py-3">No Candidates Found</p>
    </div>
  </div>
</div> -->
<!-- <app-create-candidate [events]="candidateSubject.asObservable()" ></app-create-candidate> -->


<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>


<ng-template #deleteTalentpool>
  <div class="modal-header b pb-0">
    <h5 class="modal-title" id="experience"></h5>
    <button data-testid="auto-app-candidate-list-button-17" type="button" class="close font-weight-normal ms-auto btn p-0 f-20" data-dismiss="modal" aria-label="Close"
      (click)="modalService.dismissAll()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body pb-6">
    <div class="row mb-6">
      <div class="col text-center">
        <p>Are you sure you want to delete this Talentpool?
        <p>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-10 mx-auto d-flex">
        <button data-testid="auto-app-candidate-list-button-18" class="btn-trms-white" (click)="modalService.dismissAll()">NO</button>
        <button data-testid="auto-app-candidate-list-button-19" class="btn-trms-small" (click)="DeleteTalentpool()">YES</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #successModal class="modal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-app-candidate-list-button-20" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col text-center">
          <img src="./../../../assets/images/success-vector.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <p class="text-center">CONGRATULATIONS !!!</p>
          <p class="text-center">{{successMessage}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-app-candidate-list-button-21" class="btn-trms-white" (click)="modalService.dismissAll()">CANCEL</button>
          <button data-testid="auto-app-candidate-list-button-22" class="btn-trms-small" (click)="modalService.dismissAll()">DONE</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #errorModal class="modal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-app-candidate-list-button-23" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col text-center">
          <img src="./../../../assets/images/error-vector.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <p class="text-center">ERROR</p>
          <p class="text-center">{{errorMessage}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-app-candidate-list-button-24" class="btn-trms-small" (click)="modalService.dismissAll()">CLOSE</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>



<ng-template #removeCandidatefromTalentpool>
  <div class="modal-header b pb-3">
    <h5 class="f-14 font-weight-600" id="experience">Archive Candidate</h5>
    <button data-testid="auto-app-candidate-list-button-25" type="button" class="close font-weight-normal p-2" data-dismiss="modal" aria-label="Close"
      (click)="modalService.dismissAll()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body pb-3 pt-0">
    <div class="row mb-3">
      <div class="col">
        <p *ngIf="talentpoolid" class="mb-0">Are you sure you want to archive Selected Candidate from Talentpool?</p>

        <p *ngIf="!talentpoolid" class="mb-0">Are you sure you want to archive Selected Candidates?</p>

      </div>
    </div>
    <div class="row mb-0">
      <div class="col d-flex justify-content-end">
        <button data-testid="auto-app-candidate-list-button-26" class="btn-trms-white mr-3" (click)="modalService.dismissAll()">No</button>
        <button data-testid="auto-app-candidate-list-button-27" class="btn-trms-small" (click)="removecandidatefromtalentpool()">Yes</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #noCreditsSE class="modal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-app-candidate-list-button-28" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-6">
        <div class="col text-center mb-4">
          <img src="../../assets/images/wallet.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col text-center ">
          <p class="font-weight-500 f-16 mb-2">Upgrade to keep going</p>
          <p class="" *ngIf="!isteamMember">You have exhausted your limit for Smart emailing</p>
          <p class="" *ngIf="isteamMember">You have exhausted your limit for Smart emailing, Request more credits from
            your team admin to keep
            going</p>
        </div>
      </div>
      <div class="row" *ngIf="!isteamMember">
        <div class="col-md-10 mx-auto d-flex">
          <!-- <button data-testid="auto-app-candidate-list-button-29" class="col-md-4 mx-auto py-3 wc-ghostBtn" (click)="modaldismiss()">CANCEL</button> -->
          <button data-testid="auto-app-candidate-list-button-30" class="btn-trms-medium" (click)="route2pricing()">Upgrade plan</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #upgradePlan class="modal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-app-candidate-list-button-31" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-6">
        <div class="col text-center mb-4">
          <img src="../../../assets/images/premium-user-error.png" style="width:400px; height:250px;">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col text-center ">
          <p class="font-weight-500 f-16 mb-2">CSV export is a paid feature</p>
          <p class="" *ngIf="!isteamMember">To be able to download these profiles as a csv file, upgrade to a better
            plan.</p>
          <p class="" *ngIf="isteamMember">To be able to download these profiles as a csv file, Request more credits
            from your team admin to keep going</p>
        </div>
      </div>
      <div class="row" *ngIf="!isteamMember">
        <div class="col-md-10 mx-auto d-flex">
          <!-- <button data-testid="auto-app-candidate-list-button-32" class="col-md-4 mx-auto py-3 wc-ghostBtn" (click)="modaldismiss()">CANCEL</button> -->
          <button data-testid="auto-app-candidate-list-button-33" class="btn-trms-medium" (click)="route2pricing()">Upgrade plan</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #bulkemailerlimit>
  <div class="modal-header b px-5 pt-5 pb-0">
    <h5 class="modal-title" id="createTalentTitle"></h5>
    <button data-testid="auto-app-candidate-list-button-34" type="button" class="close font-weight-normal" data-dismiss="modal" aria-label="Close"
      (click)="modalService.dismissAll()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body pb-6">
    <div class="row mt-6 mb-6">
      <div class="col text-center">
        <p>You can email maximum 10 candidates at a time. You have selected more than 10 candidates</p>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-10 mx-auto d-flex">
        <button data-testid="auto-app-candidate-list-button-35" class="btn-trms-small" (click)="modalService.dismissAll()">OK</button>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #noEmailModal class="modal reloginmodal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-app-candidate-list-button-36" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col text-center">
          <img src="./../../../assets/images/unauthorised.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <p class="text-center">Please select atleast one candidate with an email id</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-app-candidate-list-button-37" class="btn-trms-small"
            (click)="modalService.dismissAll()">Done</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #addCandidateToEmailCampaign let-modal>
  <div class="modal-header b pb-0">
    <h5 class="f-14 font-weight-600" id="experience">Add Candidate to Email Campaign</h5>
    <button data-testid="auto-app-candidate-list-button-38" type="button" class="close font-weight-normal ms-auto btn p-0 f-20"  data-dismiss="modal" aria-label="Close"
      (click)="closeActiveModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body pb-3 pt-0">
    <div class="row mb-2 mt-2">
      <div class="col">
        <input data-testid="auto-app-candidate-list-input-3"
          type="text"
          class="wc-form-control no-shadow w-100 inputheight mb-2"
          placeholder="Enter Campaign Name...."
          [formControl]="campaign_input"
          [matAutocomplete]="campaign_name"
          (input)="onTypeAheadSearch($event)"
          (click)="onTypeAheadSearch($event)"
        />
        <p *ngIf="campaign_input.errors?.required && (campaign_input.dirty || campaign_input.touched)"
                class="f-12 text-danger">Campaign Name is required</p>

        <mat-autocomplete #campaign_name="matAutocomplete" (optionSelected)="onCampaignSelected($event.option.value)">
          <mat-option *ngFor="let campaign of campaignList" [value]="campaign" [disabled]="campaign.remaining_targets <= 0">
            <div class="d-flex justify-content-between align-items-center">
              <span>{{ campaign.campaign_name }}</span> <span class="badge badge-light border f-12 font-weight-normal text-9696" *ngIf="campaign.remaining_targets <= 0">Campaign limits reached</span>
            </div>
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
    <div class="row mb-0">
      <div class="col  d-flex justify-content-end">
        <button data-testid="auto-app-candidate-list-button-39" class="btn-trms-small" (click)="!isLoadingEmailCampaignApi && addToEmailCampaignV2()" [disabled]="!campaign_input.valid">
          <span *ngIf="!isLoadingEmailCampaignApi">
            Add
          </span>
          <span *ngIf="isLoadingEmailCampaignApi">
            <img style="width: 20px;" src="../../../assets/rolling-loader-white.gif" alt="">
          </span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #addCandidateToScreenAiModal>
  <div class="modal-content">
    <div class="modal-header b pb-0">
      <h5 class="f-14 font-weight-600" id="downloadCSVModalHeading">Add to Screen AI</h5>
      <button data-testid="auto-app-candidate-list-button-40" type="button" class="close font-weight-normal ms-auto btn p-0 f-20" data-dismiss="modal" aria-label="Close"
        (click)="closeActiveModal()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body pb-3 pt-0">
      <div *ngIf="!screenAiDuplicateCheckDone">
        <div class="row mb-2 mt-2">
          <div class="col">
            <input data-testid="auto-app-candidate-list-input-4"
              type="text"
              class="wc-form-control no-shadow w-100 inputheight mb-2"
              placeholder="Enter Job Name...."
              [formControl]="job_input"
              [matAutocomplete]="job_name"
              (click)="getAllScreenAIJobs()"
            />
            <p *ngIf="job_input.errors?.required && (job_input.dirty || job_input.touched)"
                    class="f-12 text-danger">Job Name is required</p>
            <mat-autocomplete #job_name="matAutocomplete" (optionSelected)="onJobSelected($event.option.value)">
              <mat-option *ngFor="let job of jobList" [value]="job" [disabled]="isScreeningInProgress(job)" [matTooltip]="getTooltipText(job)" [matTooltipClass]="{ 'eu-tooltip text-black': true }" matTooltipPosition="above">
                {{ job.name }} <span class="float-right text-right ml-auto f-12 mt-2 text-9696" *ngIf="job.batch_status === 'pending'">Screening in progress</span>
              </mat-option>
            </mat-autocomplete>
          </div>
        </div>
        <div class="row mb-0">
          <div class="col  d-flex justify-content-end">
            <button data-testid="auto-app-candidate-list-button-41" class="btn-trms-small" (click)="!isLoadingScreenAiApi && addToScreenAi()" [disabled]="!job_input.valid">
              <span *ngIf="!isLoadingScreenAiApi">
                Add
              </span>
              <span *ngIf="isLoadingScreenAiApi">
                <img style="width: 20px;" src="../../../assets/rolling-loader-white.gif" alt="">
              </span>
            </button>
          </div>
        </div>
        </div>
      <ng-container *ngIf="screenAiDuplicateCheckDone">
        <div class="px-3">
        <p>{{postAddMssg}}</p>
        <div class="float-right d-flex flex-row justify-content-end mb-2">
          <button data-testid="auto-app-candidate-list-button-42" class="outlined-button" *ngIf="addCandidateSuccess" style="width: fit-content; padding: 1rem; border-radius: .3125rem;" (click)="redirectToScreenAi()">
            View Screen AI
          </button>
          <button data-testid="auto-app-candidate-list-button-43"  (click)="closeActiveModal()" class="ml-2 enabled-button" style="width: fit-content; padding: 1rem; border-radius: .3125rem;">
            <span *ngIf="addCandidateSuccess" (click)="ngOnInit()">Continue Search</span>
            <span *ngIf="!addCandidateSuccess">Close</span>
          </button>
        </div>
    </div>
      </ng-container>
    </div>
    </div>
</ng-template>

<!-- bulk-download-as-csv modal -->
<ng-template #bulkDownloadAsCSVModal>
  <div class="modal-content">
    <div class="modal-header b pb-0">
      <h5 class="f-14 font-weight-600" id="downloadCSVModalHeading">Download profiles as CSV</h5>
      <button data-testid="auto-app-candidate-list-button-44" type="button" class="close font-weight-normal" data-dismiss="modal" aria-label="Close"
        (click)="closeActiveModal()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body pb-3 pt-0">
      <div class="row mb-2 mt-2">
        <div class="col">
          <p class="mb-1">Please select: </p>

          <div class="position-relative no-outline d-flex flex-column">
            <label for="currentPageRadioBtn" class="customeRadioBtn my-1">
              Current page profiles ({{ selectedcandidate?.length || 0 }})
              <input data-testid="auto-app-candidate-list-input-5" type="radio" name="downloadSelection" (change)="bulkDownloadCSVSelectedOption = 'currentPage'" [(ngModel)]="bulkDownloadCSVSelectedOption" value="currentPage" id="currentPageRadioBtn">
              <span class="checkmark"></span>
            </label>
            <label for="entireListingRadioBtn" class="customeRadioBtn my-1">
              All profiles ({{ totalBulkCandidateNumbersAfterExclusions?.length || 0 }})
              <input data-testid="auto-app-candidate-list-input-6" type="radio" name="downloadSelection" (change)="bulkDownloadCSVSelectedOption = 'All'" [(ngModel)]="bulkDownloadCSVSelectedOption" value="All" id="entireListingRadioBtn">
              <span class="checkmark"></span>
            </label>
          </div>
        </div>
      </div>

      <div class="row mb-0">
        <div class="col d-flex justify-content-end">
          <button data-testid="auto-app-candidate-list-button-45" class="btn-trms-white mr-3" (click)="closeActiveModal()">No</button>
          <button data-testid="auto-app-candidate-list-button-46" class="btn-trms-small" [disabled]="!bulkDownloadCSVSelectedOption" [ngClass]="{'disabled': !bulkDownloadCSVSelectedOption}" [ngStyle]="{'cursor': !bulkDownloadCSVSelectedOption ? 'not-allowed' : 'pointer' }" (click)="DownloadCandidateCSV()">
            <span *ngIf="!processingCSVDownload">
              Yes
            </span>
            <span *ngIf="processingCSVDownload">
              <img style="width: 20px;" src="../../assets/rolling-loader-white.gif" alt="">
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #addToEmailCampaignWithViewCampaign let-modal>
  <div class=" p-2 text-white" style="background-color: #53EBA4;">
    <p class="mb-0 d-flex align-items-center"><span><i class="fa-solid fa-check mx-2 text-white f-18"></i></span> <span>Profile added to Campaign</span><span class="text-truncate pointer font-weight-600" style="text-decoration: underline;width: 230px;" (click)="redirectToEmailCampaign(selectedCampaign?.campaign_id)">"{{campaignName}}".</span></p>
  </div>
</ng-template>
